import { useRef, useState, useLayoutEffect } from 'react';

const useLabelSmartPosition = (x, y) => {
  const ref = useRef(null);
  const [pos, setPos] = useState({
    left: x + 14,
    top: y - 24,
    visibility: 'hidden',
  });

  useLayoutEffect(() => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const MARGE = 8;
    let left = x + 14;
    let top = y - 24;
    if (left + rect.width > window.innerWidth - MARGE) {
      left = x - rect.width - 8;
    }
    if (left < MARGE) left = MARGE;
    if (top + rect.height > window.innerHeight - MARGE) {
      top = window.innerHeight - rect.height - MARGE;
    }
    if (top < MARGE) top = MARGE;
    setPos({ left, top, visibility: 'visible' });
  }, [x, y]);

  return { ref, pos };
};

export default useLabelSmartPosition;
